export const criteriaSectionMessagesEn = {
  // cohort builder components - cohortBuilderDefinitionCard
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.variableName': 'Variable name',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.type': 'Type',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.off': 'Off',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.inclusion': 'Inclusion',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.exclusion': 'Exclusion',
  'projects.cohortBuilderPage.cohortBuilderDefinitionCard.criteria': 'Criteria selection',

  // cohort builder components - CriteriaSection
  'projects.cohortBuilderPage.criteriaSection.title': 'Criteria',
  'projects.cohortBuilderPage.criteriaSection.noDefinitionVariablesMainMsg': 'No criteria',
  'projects.cohortBuilderPage.criteriaSection.noDefinitionVariablesSubMsg':
    'Define a criterion to get started',
};
